// extracted by mini-css-extract-plugin
export default {"card":"j0-z","carouselContainer":"k0-z","carouselContent":"l0-z"};